import { useContext } from 'react'

import { CountersActionsContext } from '../context'

export function useRefetchCounters() {
  return useContext(CountersActionsContext)
}
